var map = {
	"./allerum-golf-club/logo.png": 486,
	"./forsbacka-golf-club/logo.png": 45702,
	"./gumbalde-resort/logo.png": 55819,
	"./isaberg-golf-club/logo.png": 27625,
	"./karlshamn-golf-club/logo.png": 15219,
	"./laholms-golf-club/logo.png": 84326,
	"./landeryd-golf-club/logo.png": 52193,
	"./linkoping-golf-club/logo.png": 17085,
	"./malaro-golf-club/logo.png": 11744,
	"./rya-golf-club/logo.png": 76080,
	"./sjobo-golf-club/logo.png": 25209,
	"./skerike-golf-club/logo.png": 47176,
	"./soderslatt-golf-club/logo.png": 64903,
	"./solvesborg-golf-club/logo.png": 51670,
	"./trummenas-golf-club/logo.png": 4768,
	"./upsala-golf-club/logo.png": 48704,
	"./varberg-golf-club/logo.png": 64471,
	"./vreta-kloster-golf-club/logo.png": 22349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25389;